/**
 * Public external-game contract.
 *
 * Generated from the fail-closed approval and exclusion ledger by
 * scripts/scrape-rosebud.mts. Every shipped entry must have a durable
 * title-and-cover receipt in wiki/product/rosebud-catalog.md.
 *
 * gatewayUrl (when present) is the game's own Rosebud game-server origin,
 * harvested at scrape time from its play page's "Universal"-mode revision.
 * Carcade's overlay frames it directly for a chrome-free game; entries
 * without one (a non-"Universal" rendering mode, or a failed harvest) fall
 * back to framing the ordinary play page.
 */
export interface ExternalGameLink {
  readonly slug: string;
  readonly title: string;
  readonly url: `https://rosebud.ai/play/${string}`;
  readonly coverUrl: string;
  readonly gatewayUrl?: `https://${string}.run.app/api/server/${string}/index.html`;
}

export const ROSEBUD_CATALOG: readonly ExternalGameLink[] = [
  {
    slug: "ping-pong",
    title: "Pocket Pong",
    url: "https://rosebud.ai/play/ping-pong",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/72470804-5188-46a1-8a49-8d544840d2c8.png?v=1780093156.690837",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/39d2c294-a486-41a0-a279-d4a174de2ab1/index.html",
  },
  {
    slug: "adjacency-boggle",
    title: "Adjacency Boggle",
    url: "https://rosebud.ai/play/adjacency-boggle",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7027d6e3-4516-4311-9da6-a964e5c9524b-thumbnail.png?v=1783693478.30543",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/cfdacfff-e881-4736-8005-62ad56bff547/index.html",
  },
  {
    slug: "3d-multiplayer-template-v1",
    title: "3D Multiplayer Template v1",
    url: "https://rosebud.ai/play/3d-multiplayer-template-v1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/9285d6e3-3e24-4669-ba6c-ebb7b52675fd.png?v=1782994063.734767",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/fde49073-2b28-4309-89d0-82561a71a77c/index.html",
  },
  {
    slug: "940b53c3-924b-4320-a307-7ae83f406881",
    title: "Cavernous Caution - A GameJam Game.",
    url: "https://rosebud.ai/play/940b53c3-924b-4320-a307-7ae83f406881",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/940b53c3-924b-4320-a307-7ae83f406881.png?v=1774053192.100809",
  },
  {
    slug: "74cbdcff-e26d-4551-997c-c34a67be0618",
    title: "Endless Highway Racing Environment",
    url: "https://rosebud.ai/play/74cbdcff-e26d-4551-997c-c34a67be0618",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/74cbdcff-e26d-4551-997c-c34a67be0618.png?v=1778704521.6057",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/d0fc443a-4f23-4199-9e8d-dde20f7c4d2a/index.html",
  },
  {
    slug: "camo-chameleon-1",
    title: "Camo Chameleon",
    url: "https://rosebud.ai/play/camo-chameleon-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/c5fa1ce2-c188-4ca1-9cb5-6fff46c19e1d.png?v=1783501952.376438",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5c99964a-83de-4224-8d24-be871ebec1c5/index.html",
  },
  {
    slug: "800a3295-ea07-4c80-a4f1-10fd8db24088",
    title: "the SkySurfer",
    url: "https://rosebud.ai/play/800a3295-ea07-4c80-a4f1-10fd8db24088",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/800a3295-ea07-4c80-a4f1-10fd8db24088.png?v=1774322682.399343",
  },
  {
    slug: "zig-drift",
    title: "Zig Drift",
    url: "https://rosebud.ai/play/zig-drift",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/09a40330-ec50-4475-8494-2b6c56557abc.jpg?v=1781270691.801818",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/8a319ae8-20d6-4b29-bdc8-47271cf96edd/index.html",
  },
  {
    slug: "2a929c95-7bc2-42a6-9dca-d624a7b24f77",
    title: "KARTKART",
    url: "https://rosebud.ai/play/2a929c95-7bc2-42a6-9dca-d624a7b24f77",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/2a929c95-7bc2-42a6-9dca-d624a7b24f77.jpg?v=1774055968.827407",
  },
  {
    slug: "3507acc3-19b8-4a00-b868-a731af6df63e",
    title: "Super Soccer!",
    url: "https://rosebud.ai/play/3507acc3-19b8-4a00-b868-a731af6df63e",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Screenshot_2025-05-05_at_6.15.24PM.png?v=1769706280.558359",
  },
  {
    slug: "ada0e8d9-1f76-43cd-953b-fa1604d52c76",
    title: "Grow a Garden Tycoon",
    url: "https://rosebud.ai/play/ada0e8d9-1f76-43cd-953b-fa1604d52c76",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ada0e8d9-1f76-43cd-953b-fa1604d52c76.png?v=1774636175.317696",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5cc497fe-30ae-408c-9101-959f06e9f26f/index.html",
  },
  {
    slug: "648d3d4a-a909-422f-af9a-4a4ff3c9938e",
    title: "Super Stack (Mobile-Friendly)",
    url: "https://rosebud.ai/play/648d3d4a-a909-422f-af9a-4a4ff3c9938e",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/648d3d4a-a909-422f-af9a-4a4ff3c9938e.png?v=1774322695.520808",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/cdfd9600-f29a-41b1-8e06-12d1b8ff41c6/index.html",
  },
  {
    slug: "d825e4b2-a382-470d-88fa-d3f977be47ac",
    title: "APOLLO 19XX",
    url: "https://rosebud.ai/play/d825e4b2-a382-470d-88fa-d3f977be47ac",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Screenshot_2025-05-05_at_6.18.41PM.png?v=1774052050.663814",
  },
  {
    slug: "34d353fe-3145-45e4-8edc-0e9044ffa210",
    title: "ZERO-HERO",
    url: "https://rosebud.ai/play/34d353fe-3145-45e4-8edc-0e9044ffa210",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Screenshot_2025-05-05_at_6.13.26PM.png?v=1774378609.677605",
  },
  {
    slug: "mini-max-velvet-velocity",
    title: "Mini Max Velvet Velocity",
    url: "https://rosebud.ai/play/mini-max-velvet-velocity",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/1a6bb8f0-423c-4cda-937c-9c773dce4fdf.jpg?v=1782287412.55631",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/14d857da-f4f3-4385-a2d5-46e619bcd26b/index.html",
  },
  {
    slug: "6f94359f-ae3e-4e4f-ae38-b582fea81273",
    title: "8192",
    url: "https://rosebud.ai/play/6f94359f-ae3e-4e4f-ae38-b582fea81273",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/6f94359f-ae3e-4e4f-ae38-b582fea81273.png?v=1774322905.443363",
  },
  {
    slug: "7ede3b86-01a0-4378-b49f-1613f7a6f36a",
    title: "Cozy Adventure",
    url: "https://rosebud.ai/play/7ede3b86-01a0-4378-b49f-1613f7a6f36a",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7ede3b86-01a0-4378-b49f-1613f7a6f36a.png?v=1774053457.105238",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/22d3f490-0182-4a4e-969c-1a3280e2c2b4/index.html",
  },
  {
    slug: "a504ac93-52b6-42dc-a735-fe54f826c4ec",
    title: "Aliens Platformer 2D",
    url: "https://rosebud.ai/play/a504ac93-52b6-42dc-a735-fe54f826c4ec",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a504ac93-52b6-42dc-a735-fe54f826c4ec.png?v=1757526299.105326",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/11220539-6aed-4420-ae33-d3ba66be9f2e/index.html",
  },
  {
    slug: "d4d555db-b085-4260-8b45-725a4ad94e33",
    title: "Overtime Rush",
    url: "https://rosebud.ai/play/d4d555db-b085-4260-8b45-725a4ad94e33",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d4d555db-b085-4260-8b45-725a4ad94e33.png?v=1774055746.735887",
  },
  {
    slug: "mini-max-neo-max",
    title: "Mini Max NEO MAX",
    url: "https://rosebud.ai/play/mini-max-neo-max",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7b12a124-9b0b-4038-b981-d6c7b8d92bf1.png?v=1782287378.217188",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/6245daa7-d779-436e-8ddf-ba1e55b60dd4/index.html",
  },
  {
    slug: "windrose-xp-os-simulator",
    title: "Windrose XP | OS Simulator",
    url: "https://rosebud.ai/play/windrose-xp-os-simulator",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/cb79e7a1-6942-4faa-ae2b-38627c748b62.png?v=1780976954.592555",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/cc55a6ee-ec13-4bef-8174-ed7b250b5cfc/index.html",
  },
  {
    slug: "taevaria-shape-your-land-shift-the-system-1",
    title: "Taevaria - Shape your Land. Shift the System.",
    url: "https://rosebud.ai/play/taevaria-shape-your-land-shift-the-system-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7aa11e26-4dc6-4c90-889a-f1cf150e3d15.png?v=1782322994.891284",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/929b8da9-3b2b-47fd-a089-4d17cb1b6bd1/index.html",
  },
  {
    slug: "cloud-climber-legends",
    title: "!UPPY",
    url: "https://rosebud.ai/play/cloud-climber-legends",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/41fbfdca-7225-44b3-a869-8c0363ff09a7.png?v=1781270623.319141",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5b803438-94f3-446a-ba2f-db8fc8816d62/index.html",
  },
  {
    slug: "desert-dunes-explorers",
    title: "Desert Dunes Explorers",
    url: "https://rosebud.ai/play/desert-dunes-explorers",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Screenshot_2025-05-05_at_6.22.52PM.png?v=1769706311.983687",
  },
  {
    slug: "5a1c739b-ac5c-406f-b5ba-169942d22241",
    title: "Infinity Tower Mobile",
    url: "https://rosebud.ai/play/5a1c739b-ac5c-406f-b5ba-169942d22241",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/5a1c739b-ac5c-406f-b5ba-169942d22241.png?v=1774054655.581033",
  },
  {
    slug: "9888d216-159c-4c7d-80c3-0b3014968545",
    title: "MAIRIO KART",
    url: "https://rosebud.ai/play/9888d216-159c-4c7d-80c3-0b3014968545",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/9888d216-159c-4c7d-80c3-0b3014968545.png?v=1778704594.942477",
  },
  {
    slug: "3441ab63-0725-4919-ae5d-552e3de613a6",
    title: "Match 3",
    url: "https://rosebud.ai/play/3441ab63-0725-4919-ae5d-552e3de613a6",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3441ab63-0725-4919-ae5d-552e3de613a6.png?v=1774323078.078361",
  },
  {
    slug: "7f54538c-08b3-47c9-9408-38184ccdd5c2",
    title: "Crowd Rush 3D",
    url: "https://rosebud.ai/play/7f54538c-08b3-47c9-9408-38184ccdd5c2",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7f54538c-08b3-47c9-9408-38184ccdd5c2.png?v=1774322916.196171",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/fda81160-69a8-4e80-a6d5-4e3046bcc601/index.html",
  },
  {
    slug: "openrct2",
    title: "OpenRCT2",
    url: "https://rosebud.ai/play/openrct2",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_March_16_2026_-_3_18PM.jpg?v=1774055659.386426",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/8308686e-3937-4005-bc29-a62ae07ec1fc/index.html",
  },
  {
    slug: "battle-for-wesnoth",
    title: "Battle for Wesnoth",
    url: "https://rosebud.ai/play/battle-for-wesnoth",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_March_16_2026_-_3_08PM.jpg?v=1774052456.346745",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ceb8be9a-073c-466d-9a7c-3363412cd028/index.html",
  },
  {
    slug: "0fd8278a-7840-469c-9574-1cf4a9ec278a",
    title: "In My Mind",
    url: "https://rosebud.ai/play/0fd8278a-7840-469c-9574-1cf4a9ec278a",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0fd8278a-7840-469c-9574-1cf4a9ec278a.png?v=1781914422.463164",
  },
  {
    slug: "41c25361-83da-4ef5-bc27-0d0047bb1146",
    title: "Neonwave sunrise striker",
    url: "https://rosebud.ai/play/41c25361-83da-4ef5-bc27-0d0047bb1146",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/41c25361-83da-4ef5-bc27-0d0047bb1146.png?v=1774499062.543618",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/8532e4c8-b4af-47ea-8a46-390da0b44b8a/index.html",
  },
  {
    slug: "browserquest-19",
    title: "BrowserQuest",
    url: "https://rosebud.ai/play/browserquest-19",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/browserquest-preview.jpg?v=1778026742.504064",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/45022d3b-b8e2-4fd4-8558-e6e0df1c75dd/index.html",
  },
  {
    slug: "pokeguessr-app",
    title: "PokéGuessr App",
    url: "https://rosebud.ai/play/pokeguessr-app",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3ba1aaf1-cd98-4104-bf67-2ea35b966fc7.png?v=1774040098.237574",
  },
  {
    slug: "retro-ant-clicking",
    title: "Klick'Ant",
    url: "https://rosebud.ai/play/retro-ant-clicking",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/bfa789d6-fb5e-471f-8507-7f1398d7352b.png?v=1777026963.441295",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/2ce1a0d7-77cc-4a2e-8a41-182503b08b91/index.html",
  },
  {
    slug: "mini-max-mini-games",
    title: "Mini Max - Mini Games!",
    url: "https://rosebud.ai/play/mini-max-mini-games",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/dbc17c7f-4d73-42dc-9ce0-762c7caf41c1.png?v=1785219336.827138",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/fd07c147-f53a-4435-81be-c17b90aa73ba/index.html",
  },
  {
    slug: "54de9a11-f973-4dfe-b1f9-687f9e17b564",
    title: "Beat My Dungeon",
    url: "https://rosebud.ai/play/54de9a11-f973-4dfe-b1f9-687f9e17b564",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/54de9a11-f973-4dfe-b1f9-687f9e17b564.png?v=1754692246.581726",
  },
  {
    slug: "98659b51-5141-422d-beb5-1be79573c539",
    title: "Voxel Forest Template",
    url: "https://rosebud.ai/play/98659b51-5141-422d-beb5-1be79573c539",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Voxel_Forest.webp?v=1757007946.808722",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/daad4c9e-92c8-41e8-8051-8dc46e2fab17/index.html",
  },
  {
    slug: "ant-necromance",
    title: "Ant Necromance",
    url: "https://rosebud.ai/play/ant-necromance",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/6cba296b-c694-4b9e-947b-9db362fa4066.png?v=1775041256.162373",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3cd89c6e-0a8d-4688-b208-826456a40875/index.html",
  },
  {
    slug: "dinosaurgorawr-mmorpg-1",
    title: "DinosaurGoRawr MMORPG",
    url: "https://rosebud.ai/play/dinosaurgorawr-mmorpg-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/dinosaur.png?v=1782994014.870606",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/33d2e14f-4ec3-4afd-a93a-e414efb711ad/index.html",
  },
  {
    slug: "1a506f9b-b242-46a7-88ae-041ce77a99eb",
    title: "Jumpja",
    url: "https://rosebud.ai/play/1a506f9b-b242-46a7-88ae-041ce77a99eb",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/1a506f9b-b242-46a7-88ae-041ce77a99eb.png?v=1774498977.634129",
  },
  {
    slug: "taevaria-survivor-1",
    title: "Taevaria Survivor",
    url: "https://rosebud.ai/play/taevaria-survivor-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/9875aa28-c9de-46a7-9e67-783144399e81.png?v=1782323095.462335",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a33c9369-870a-46de-8208-3396de6f5aaa/index.html",
  },
  {
    slug: "c3a592ba-cfde-42fc-b51e-d28ddf08977a",
    title: "Fun with Flags",
    url: "https://rosebud.ai/play/c3a592ba-cfde-42fc-b51e-d28ddf08977a",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/c3a592ba-cfde-42fc-b51e-d28ddf08977a.jpg?v=1776808230.547275",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/85abdc0d-92f3-43c7-937c-b96a3cae7f9f/index.html",
  },
  {
    slug: "pumpkin-says",
    title: "Pumpkin Says",
    url: "https://rosebud.ai/play/pumpkin-says",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/4ce17d1f-5039-4553-86ae-4cfbc7b36ef0.jpg?v=1774055868.940299",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/61976bdf-9eac-4d1f-8730-c8cc7b4c4312/index.html",
  },
  {
    slug: "1afb236d-3c78-4c8a-8265-84a82011f5ef",
    title: "Astris",
    url: "https://rosebud.ai/play/1afb236d-3c78-4c8a-8265-84a82011f5ef",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Gemini_Generated_Image_7jpalh7jpalh7jpa.png?v=1774322710.519882",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/92a8f7bc-7829-4b11-adf9-899587c80888/index.html",
  },
  {
    slug: "ae15f484-f620-4238-adf8-0ffc3dff359f",
    title: "Arena Pong",
    url: "https://rosebud.ai/play/ae15f484-f620-4238-adf8-0ffc3dff359f",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ae15f484-f620-4238-adf8-0ffc3dff359f.png?v=1769475609.377582",
  },
  {
    slug: "2dd3db82-8417-4644-887e-ffa1be44c1f6",
    title: "Happy Racer",
    url: "https://rosebud.ai/play/2dd3db82-8417-4644-887e-ffa1be44c1f6",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/2dd3db82-8417-4644-887e-ffa1be44c1f6.gif?v=1774054447.634172",
  },
  {
    slug: "5820467e-8b76-4a84-94ed-4d9980f055ca",
    title: "Deja Vu",
    url: "https://rosebud.ai/play/5820467e-8b76-4a84-94ed-4d9980f055ca",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/5820467e-8b76-4a84-94ed-4d9980f055ca.png?v=1754691333.697959",
  },
  {
    slug: "7c866ed1-e316-4c5d-b228-23ef23181e8a",
    title: "Voxel First-Person RPG Template",
    url: "https://rosebud.ai/play/7c866ed1-e316-4c5d-b228-23ef23181e8a",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/First_Person_RPG.webp?v=1762987718.507202",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/1ff04abc-179c-4e91-88df-ebd060682b06/index.html",
  },
  {
    slug: "multiplayer-obstacle-course",
    title: "Cinematic Obstacle Course",
    url: "https://rosebud.ai/play/multiplayer-obstacle-course",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/bed87509-0a1f-4c2b-8db2-5e794063fb81.png?v=1774322807.512666",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/fce3d457-bb0f-40dd-8571-2b030d3ae5eb/index.html",
  },
  {
    slug: "midnight-rider",
    title: "Midnight Rider",
    url: "https://rosebud.ai/play/midnight-rider",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/88726010-46f3-419c-867a-486f1388e9c2.png?v=1779727663.366574",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/4745f6bc-cfc6-42b3-adf8-3c4deebd3c2f/index.html",
  },
  {
    slug: "patisserie-petit-2",
    title: "Wedding Cake Wonders",
    url: "https://rosebud.ai/play/patisserie-petit-2",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/c8a239d1-4f22-4a4b-a1a0-381b79ff62c3.png?v=1781546785.362857",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/cd712eba-90bc-4114-809d-c9cd43c2ff78/index.html",
  },
  {
    slug: "228717b5-c65e-47fb-b122-b5c487eb32e9",
    title: "🟢Roller  Sprint 3-D🔴 [BETA]",
    url: "https://rosebud.ai/play/228717b5-c65e-47fb-b122-b5c487eb32e9",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/228717b5-c65e-47fb-b122-b5c487eb32e9.webp?v=1774499110.50141",
  },
  {
    slug: "28031613-05e4-458d-87cc-15c9bad72b7d",
    title: "forest2.0",
    url: "https://rosebud.ai/play/28031613-05e4-458d-87cc-15c9bad72b7d",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Screenshot_2025-07-31_at_10.44.13AM.png?v=1769731465.849931",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/d5c9f45a-f69a-4df0-8d99-9dce9244cacd/index.html",
  },
  {
    slug: "6df1ea2d-7f9d-422e-8787-99fbe73b732c",
    title: "ASCII Duck",
    url: "https://rosebud.ai/play/6df1ea2d-7f9d-422e-8787-99fbe73b732c",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/6df1ea2d-7f9d-422e-8787-99fbe73b732c.png?v=1754518400.7426",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/4be320a5-768a-47ef-a4bf-f0587e486950/index.html",
  },
  {
    slug: "vieraville",
    title: "Vieraville",
    url: "https://rosebud.ai/play/vieraville",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f879c27c-7f8e-40b1-8a51-56a9e9afa1dd.png?v=1774057144.678596",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/aea4da1b-0b04-422a-a637-3c7cbf4d40ea/index.html",
  },
  {
    slug: "545a3b48-e16e-4f55-b779-66d93813c924",
    title: "Ferment!",
    url: "https://rosebud.ai/play/545a3b48-e16e-4f55-b779-66d93813c924",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ferment_thumbnail.png?v=1769706352.503211",
  },
  {
    slug: "mindustry-classic",
    title: "Mindustry Classic",
    url: "https://rosebud.ai/play/mindustry-classic",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/mindustry-classic-16x9.jpg?v=1775053866.688787",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5b832b82-44bc-4e89-a1d6-6b47b49343c7/index.html",
  },
  {
    slug: "bd4597c1-fd1a-43bf-ba1d-86e58da16daa",
    title: "Cozy Pomodoro",
    url: "https://rosebud.ai/play/bd4597c1-fd1a-43bf-ba1d-86e58da16daa",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/bd4597c1-fd1a-43bf-ba1d-86e58da16daa.jpeg?v=1774284810.408124",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7936d6c9-06df-4451-b363-b247a1a48f7d/index.html",
  },
  {
    slug: "unciv-base",
    title: "Unciv Original",
    url: "https://rosebud.ai/play/unciv-base",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_March_17_2026_-_3_57PM.jpg?v=1775155193.530327",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/96f00576-2558-4dcc-b769-b3d32bdfcff0/index.html",
  },
  {
    slug: "doubleswaps",
    title: "DoubleSwaps",
    url: "https://rosebud.ai/play/doubleswaps",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/35943872-0f2e-4942-b615-598f8ecf55ae.png?v=1786925636.863592",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a9b7ff66-59f5-4347-84e3-1b78679e6f7d/index.html",
  },
  {
    slug: "astrorunner-pc",
    title: "Astrorunner (PC)",
    url: "https://rosebud.ai/play/astrorunner-pc",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/6419d389-5a9e-41d5-882d-1f6fa7d176ed.png?v=1774322636.561327",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/0bbeaef0-19b7-43b4-97f0-d9f0bd8cc47c/index.html",
  },
  {
    slug: "tron-gridlock",
    title: "Tron Gridlock",
    url: "https://rosebud.ai/play/tron-gridlock",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/43404945-5d17-4b71-ad23-3f1e43202ee2.png?v=1774323030.318748",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a6729f50-0e7b-424c-bb0e-b769b68f905f/index.html",
  },
  {
    slug: "think-again",
    title: "Think Again",
    url: "https://rosebud.ai/play/think-again",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/598640b2-a8e4-4be3-94f8-fc7b282d7d81.png?v=1782994198.81779",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b92bce5b-ad9e-4238-846d-0b220f484f04/index.html",
  },
  {
    slug: "microcity",
    title: "MicroCity",
    url: "https://rosebud.ai/play/microcity",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/microcity-16x9.jpg?v=1775053895.393762",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/db3f6852-f66d-404e-a444-14c4a3970e2c/index.html",
  },
  {
    slug: "can-bounce-trickshot",
    title: "Can Bounce?",
    url: "https://rosebud.ai/play/can-bounce-trickshot",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/00725225-0bc4-4fc3-ab36-bfd1eaf8a115.png?v=1781270668.062714",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7e22b55e-94b3-4c26-b31a-60087c52cb3a/index.html",
  },
  {
    slug: "397acfe3-b2b9-46e4-a507-7b2183d7e7ec",
    title: "Time Loop Postman",
    url: "https://rosebud.ai/play/397acfe3-b2b9-46e4-a507-7b2183d7e7ec",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/397acfe3-b2b9-46e4-a507-7b2183d7e7ec.png?v=1750356857.513577",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7be32653-c7fd-4eee-8b80-1aebeb4cbb01/index.html",
  },
  {
    slug: "tiny-tennis",
    title: "Tiny Tennis",
    url: "https://rosebud.ai/play/tiny-tennis",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/1cf1ce0a-911e-4e6d-b6ee-49c5ef92c9a1.png?v=1780729276.316798",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/be952a55-9594-498a-865b-90160fdfe788/index.html",
  },
  {
    slug: "clean-slate-cubes-1",
    title: "OpenTTD",
    url: "https://rosebud.ai/play/clean-slate-cubes-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_March_16_2026_-_3_35PM.jpg?v=1774055682.208335",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ac5f779b-eb78-410e-942c-b5c051acd7ee/index.html",
  },
  {
    slug: "444a8f2e-a60d-410e-abb7-443e5f14ff2c",
    title: "Is This The Only Level?",
    url: "https://rosebud.ai/play/444a8f2e-a60d-410e-abb7-443e5f14ff2c",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/444a8f2e-a60d-410e-abb7-443e5f14ff2c.png?v=1774055350.659538",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/366e4cf7-e02b-4a39-a943-a3492f387d66/index.html",
  },
  {
    slug: "d3c141a0-c316-4ddc-8e60-e4d4eae4eb22",
    title: "Alien Waterworld",
    url: "https://rosebud.ai/play/d3c141a0-c316-4ddc-8e60-e4d4eae4eb22",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d3c141a0-c316-4ddc-8e60-e4d4eae4eb22.png?v=1762542595.626588",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5693e901-239e-4ce2-b6c6-4ac9256b5b96/index.html",
  },
  {
    slug: "squid-game-multiplayer-obby",
    title: "Squid Game Multiplayer Obby",
    url: "https://rosebud.ai/play/squid-game-multiplayer-obby",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ChatGPT_Image_May_11_2026_02_01_53_PM.png?v=1778813971.62828",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/477184d0-c02d-408c-b1e8-c894b3b8b22f/index.html",
  },
  {
    slug: "8a345770-7820-42f6-bd51-e532c1651b0f",
    title: "MINIMAL",
    url: "https://rosebud.ai/play/8a345770-7820-42f6-bd51-e532c1651b0f",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/8a345770-7820-42f6-bd51-e532c1651b0f.gif?v=1782504595.68747",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ae0f9bd9-5083-43a9-9447-fbba6d0abdf1/index.html",
  },
  {
    slug: "chibi-animal-friends-coloring-book",
    title: "Chibi Animal Friends Coloring Book",
    url: "https://rosebud.ai/play/chibi-animal-friends-coloring-book",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/1ca5a7dc-47d9-442a-b1ee-654ff038dc02.png?v=1782176160.315717",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/e180141c-4bea-40f1-be6f-e2ee9f0fc731/index.html",
  },
  {
    slug: "evoscape-eat-evolve-thrive",
    title: "EvoScape: Eat. Evolve. Thrive.",
    url: "https://rosebud.ai/play/evoscape-eat-evolve-thrive",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/8b54191d-a0f3-44ae-8db2-f27da0c28cdc.png?v=1776808802.836529",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/bd191453-9358-40f8-bc7c-e78064413ba7/index.html",
  },
  {
    slug: "toy-charge",
    title: "Toy Charge",
    url: "https://rosebud.ai/play/toy-charge",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/49923a72-e9a2-4014-8afa-5650ef981abf.jpeg?v=1787420141.023824",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/6b3ab162-9f1a-4c8f-8b32-da32e77432b1/index.html",
  },
  {
    slug: "misclassified",
    title: "ShapeWorks",
    url: "https://rosebud.ai/play/misclassified",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ca60ee49-5ae5-4751-aa03-029e2caddd5f.png?v=1785826076.096618",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/1d3f8a45-6838-4926-a80e-fdf54419962b/index.html",
  },
  {
    slug: "unciv-wizarding-high",
    title: "Unciv Wizarding",
    url: "https://rosebud.ai/play/unciv-wizarding-high",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_March_16_2026_-_3_14PM.jpg?v=1774973822.850416",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/34b7c194-ace2-4ed4-b692-dd1d8b1094e5/index.html",
  },
  {
    slug: "farmhand",
    title: "FarmHand",
    url: "https://rosebud.ai/play/farmhand",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a2a861b9-9287-4d31-b41e-ef2db54a5bb7.webp?v=1775053878.968094",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/58d89682-fe98-4258-a49b-d126efcfdc10/index.html",
  },
  {
    slug: "super-swipe-striker",
    title: "Kick-O-Licious",
    url: "https://rosebud.ai/play/super-swipe-striker",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/19fd3170-4517-459a-b8b1-48df3626d0c7.png?v=1781973852.340015",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/6e94f1d7-2721-4723-a4aa-da5458783269/index.html",
  },
  {
    slug: "traveller-3",
    title: "TRAVELLER",
    url: "https://rosebud.ai/play/traveller-3",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/8fcaccde-4b4a-4009-a284-c58b4618c501.jpg?v=1787864634.043459",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/893b256e-cb19-406d-bf23-678112db75cc/index.html",
  },
  {
    slug: "roundhouse-soccer-1",
    title: "Roundhouse Soccer #1",
    url: "https://rosebud.ai/play/roundhouse-soccer-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_April_23_2026_-_9_14AM.jpg?v=1777649388.325923",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3f0cf2d3-a1a6-40c0-afad-4662280b4856/index.html",
  },
  {
    slug: "all-4-sides",
    title: "All 4 Sides",
    url: "https://rosebud.ai/play/all-4-sides",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/aa5f4f7a-1d0b-4e05-a387-2205042a0268.png?v=1784136934.024629",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/bae4d3b9-eff0-4d45-9a5f-54b47f77fd88/index.html",
  },
  {
    slug: "velo-ag",
    title: "VELO AG",
    url: "https://rosebud.ai/play/velo-ag",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3b849171-deb5-476f-9edb-70f9b47625cc.png?v=1780265696.797567",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7a9aa1d3-14ee-424b-b0ac-74a06f094802/index.html",
  },
  {
    slug: "zen-glide-autopilot",
    title: "Autopilot",
    url: "https://rosebud.ai/play/zen-glide-autopilot",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/af69769d-e88c-494b-8c5a-e5d54854b2fc.png?v=1783188019.86818",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/02a013cd-958e-4b15-a236-b5f73d0b839d/index.html",
  },
  {
    slug: "midnight-racer",
    title: "Midnight Racer",
    url: "https://rosebud.ai/play/midnight-racer",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a9f342c5-44fd-4614-8f99-913ae3003457.png?v=1780981716.502929",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9b140169-a3c9-423a-9861-ff34452a76cf/index.html",
  },
  {
    slug: "fallout-multiplayer-obby",
    title: "Fallout Multiplayer Obby",
    url: "https://rosebud.ai/play/fallout-multiplayer-obby",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ChatGPT_Image_May_11_2026_02_05_25_PM.png?v=1778533741.886865",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/07668be9-fb6e-4155-a70a-0b375962bdf6/index.html",
  },
  {
    slug: "8812a11d-ebd5-46cc-b88c-53035a672140",
    title: "#HEXXED",
    url: "https://rosebud.ai/play/8812a11d-ebd5-46cc-b88c-53035a672140",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/8812a11d-ebd5-46cc-b88c-53035a672140.png?v=1774054520.527482",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/934d0e80-3270-43c3-8cd6-981317fcd1e8/index.html",
  },
  {
    slug: "candy-merge",
    title: "Candy Merge",
    url: "https://rosebud.ai/play/candy-merge",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3135fb61-185a-4f2e-8f29-4ac05791d99b-thumbnail.png?v=1784403238.820771",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/24b41326-9651-43de-a9cc-60671b370342/index.html",
  },
  {
    slug: "zen-tapper",
    title: "Zen Tapper",
    url: "https://rosebud.ai/play/zen-tapper",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ChatGPT_Image_May_13_2026_12_27_52_PM.png?v=1778700482.521096",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ec3d3d78-67c3-4f0d-ab41-f7c22bb61b78/index.html",
  },
  {
    slug: "d311962c-2163-4f74-9665-a609cfde0907",
    title: "Pixel Shmup",
    url: "https://rosebud.ai/play/d311962c-2163-4f74-9665-a609cfde0907",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Screenshot_2024-03-07_at_6.13.48PM.png?v=1774499085.674431",
  },
  {
    slug: "7915e366-7b1e-49f5-a766-f5fdba239415",
    title: "SUMO. by WURM",
    url: "https://rosebud.ai/play/7915e366-7b1e-49f5-a766-f5fdba239415",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/image_2024-07-21_201840103.png?v=1774499157.814675",
  },
  {
    slug: "7d3e6244-51f5-4698-a839-8a8325725dad",
    title: "Fruit Merge",
    url: "https://rosebud.ai/play/7d3e6244-51f5-4698-a839-8a8325725dad",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7d3e6244-51f5-4698-a839-8a8325725dad.png?v=1758628756.086802",
  },
  {
    slug: "neon-descent-1",
    title: "Neon Descent",
    url: "https://rosebud.ai/play/neon-descent-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ChatGPT_Image_May_13_2026_12_31_05_PM.png?v=1778700677.177802",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/bb3fdf0a-2926-450a-933a-99237b08f9f2/index.html",
  },
  {
    slug: "daemon-loop",
    title: "Daemon Loop",
    url: "https://rosebud.ai/play/daemon-loop",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_March_04_2026_-_12_40PM.jpg?v=1774053605.066001",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5c9a1804-dbb5-47aa-975d-c7026bcb60d6/index.html",
  },
  {
    slug: "drawtopia",
    title: "Drawtopia",
    url: "https://rosebud.ai/play/drawtopia",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f6de99fa-340f-4c85-bb53-ef8b4f3a50ac.jpg?v=1779729035.926719",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/39ac0085-eddd-4e53-8675-74c489e3f817/index.html",
  },
  {
    slug: "p-rogue-e",
    title: "P-Rogue-i",
    url: "https://rosebud.ai/play/p-rogue-e",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/b1fbbf01-1570-447e-a63a-0cead7bd0122.png?v=1786262909.008448",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/0885e196-ed65-4f38-964c-dad4c5db77f0/index.html",
  },
  {
    slug: "cluster-duck-thwompin-time-1",
    title: "Cluster Duck Thwompin Time",
    url: "https://rosebud.ai/play/cluster-duck-thwompin-time-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/80433ca9-952d-4832-99ff-d1cf79d5f8a2-thumbnail.jpg?v=1786636963.730012",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/fa4809de-b7f0-4258-9269-5b881a088d13/index.html",
  },
  {
    slug: "9ecb4afe-13ed-467e-a393-fb3720bf0080",
    title: "Sudoku Solver Supreme",
    url: "https://rosebud.ai/play/9ecb4afe-13ed-467e-a393-fb3720bf0080",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/9ecb4afe-13ed-467e-a393-fb3720bf0080.png?v=1774322771.957944",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/419e9965-4d56-403d-8266-af099c193dd3/index.html",
  },
  {
    slug: "beastgrid",
    title: "Beastgrid",
    url: "https://rosebud.ai/play/beastgrid",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d2f65c4f-a224-49a9-9a70-df84b59f3654.jpg?v=1774498868.393708",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/d9feb29c-283c-4e3b-8d6a-a8d9792f960a/index.html",
  },
  {
    slug: "neon-marble",
    title: "Neon Marble",
    url: "https://rosebud.ai/play/neon-marble",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/28b23629-3378-473c-9186-d779e2401687.jpg?v=1780976986.044713",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/c2d4bc3d-4af8-4a0f-9529-6ff49d93929e/index.html",
  },
  {
    slug: "not-a-parrot-racing-game",
    title: "Not A Parrot Racing Game",
    url: "https://rosebud.ai/play/not-a-parrot-racing-game",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e6befdfc-3a1a-43c8-a43e-ede6683faf32.png?v=1783590202.977187",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9fc443dc-f6ac-4f90-bf78-d99a30da3aae/index.html",
  },
  {
    slug: "untrusted",
    title: "Untrusted",
    url: "https://rosebud.ai/play/untrusted",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e416c297-513e-456a-9c14-4ca95c42927a.jpg?v=1775053814.516666",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3c0e8c1d-62f3-4f2f-97a1-fffe1159069b/index.html",
  },
  {
    slug: "out-of-office",
    title: "Out of Office",
    url: "https://rosebud.ai/play/out-of-office",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ea666a23-f5ea-45f1-bc77-fe83a08dbb52.jpeg?v=1787258567.714266",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/d3a59ae4-1622-456a-a285-ebe431f1b338/index.html",
  },
  {
    slug: "orbital-jam-2",
    title: "Orbital Jam",
    url: "https://rosebud.ai/play/orbital-jam-2",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/8018f276-0316-434d-839c-954008e74591.jpeg?v=1787136590.495551",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9e975b1f-ef12-4586-8fdc-27bdee5cafb3/index.html",
  },
  {
    slug: "sticky-bunny",
    title: "STICKY BUNNY",
    url: "https://rosebud.ai/play/sticky-bunny",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/019ac57e-d549-4e14-9703-81d222c92256.png?v=1780906529.094566",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/e9325fed-7d01-4f14-a54a-e948230505ec/index.html",
  },
  {
    slug: "paddle-pong-3d",
    title: "Paddle & Pong 3D",
    url: "https://rosebud.ai/play/paddle-pong-3d",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/4de4f366-e4be-4809-9d4f-269d380ee693.png?v=1778237227.279501",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/abe16c88-69ad-4797-97d0-4cb7445578c2/index.html",
  },
  {
    slug: "idle-clicker-cruise-ship-tycoon",
    title: "Idle Clicker: Cruise Ship Tycoon",
    url: "https://rosebud.ai/play/idle-clicker-cruise-ship-tycoon",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/117f139a-b54a-416f-afa5-6fb8982134db.png?v=1774901421.248568",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7253f9ee-965d-42ab-b92b-b9d3ee25fe80/index.html",
  },
  {
    slug: "keyblock-run",
    title: "Keyblock Run",
    url: "https://rosebud.ai/play/keyblock-run",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/caa7f8d9-45e3-4f9a-8592-1614f6cca902-thumbnail.jpg?v=1785126530.144544",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b1e74bec-8f77-4eec-ae97-9914fa14cd7b/index.html",
  },
  {
    slug: "crate-digging-fever",
    title: "Crate Digging Fever",
    url: "https://rosebud.ai/play/crate-digging-fever",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/82499b38-7edc-4feb-82dd-15ffa1006ace.png?v=1786044161.916567",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/805e9bea-0abb-4aec-89a8-c4fb4986e315/index.html",
  },
  {
    slug: "mowzone",
    title: "MOWZONE",
    url: "https://rosebud.ai/play/mowzone",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/b74f6ea7-f96e-41fb-9c0d-9d6f2963fa20.png?v=1780905761.649086",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a75704ee-38b1-4704-90fc-a5b12996f452/index.html",
  },
  {
    slug: "tidy-prizes",
    title: "Tidy Prizes",
    url: "https://rosebud.ai/play/tidy-prizes",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/36da346a-908f-4466-9ee5-c8705435534d.png?v=1780906111.7554",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/bb90e68f-d12a-48bf-904d-b7a8648521a8/index.html",
  },
  {
    slug: "baef816e-aab9-4ed0-96c9-11779045fc95",
    title: "Sugar Smart Adventures",
    url: "https://rosebud.ai/play/baef816e-aab9-4ed0-96c9-11779045fc95",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Gemini_Generated_Image_xadaf0xadaf0xada.png?v=1764697026.181139",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/d8f043c1-1dcf-4f3c-98f9-a13186a1522d/index.html",
  },
  {
    slug: "traino",
    title: "TRAINO",
    url: "https://rosebud.ai/play/traino",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/51bdebfc-adc4-4a9b-a887-9b726a42b20f.png?v=1781263643.594387",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/e5ed4cfd-5628-458e-ac24-ab4bfb995d11/index.html",
  },
  {
    slug: "5ee09726-b999-48fc-b9aa-92ad607a9858",
    title: "Spectro Ninjas",
    url: "https://rosebud.ai/play/5ee09726-b999-48fc-b9aa-92ad607a9858",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/5ee09726-b999-48fc-b9aa-92ad607a9858.png?v=1779729266.251396",
  },
  {
    slug: "true-8-ball",
    title: "True 8-Ball",
    url: "https://rosebud.ai/play/true-8-ball",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0000cfc5-9470-4045-b16a-21272c8cfb9d-thumbnail.png?v=1783510953.646262",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/206c0c82-25c6-4322-90e3-085cc7f1e9ac/index.html",
  },
  {
    slug: "gap-flap",
    title: "Gap Flap",
    url: "https://rosebud.ai/play/gap-flap",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f334a7cd-26f7-4dda-80bb-9bdd1fb1695b-thumbnail.jpg?v=1785722968.525778",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/1ee967e0-0bf4-4284-9037-3f73068a3b50/index.html",
  },
  {
    slug: "shadow-pulse-1",
    title: "Video Puzzle",
    url: "https://rosebud.ai/play/shadow-pulse-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_March_17_2026_-_4_07PM.jpg?v=1775109647.958857",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/afdc9795-69ad-4e9a-9568-909048aab7d5/index.html",
  },
  {
    slug: "when-pigs-fly-1",
    title: "When Pigs Fly",
    url: "https://rosebud.ai/play/when-pigs-fly-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0109276a-1895-4ad1-a75b-8d67c30b3589.webp?v=1780265757.876674",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/abd2b1b1-ca0c-4085-85a0-7161b989b05c/index.html",
  },
  {
    slug: "new-word-dungeon-game",
    title: "Word Dungeon",
    url: "https://rosebud.ai/play/new-word-dungeon-game",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/04fb05b1-7a22-4f97-8a41-dd0643655bb3.jpg?v=1779729086.091446",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/385956e3-a582-4579-b6ed-df828672bd16/index.html",
  },
  {
    slug: "free-the-fuzzies",
    title: "Free the Fuzzies",
    url: "https://rosebud.ai/play/free-the-fuzzies",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/59886e5a-6d94-4ba5-b53f-7ed6cf542d05-thumbnail.jpg?v=1786473354.756536",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7926474c-6bb5-4729-a390-8b5401c2e74b/index.html",
  },
  {
    slug: "garden-disk-corp",
    title: "Garden Disk Corp",
    url: "https://rosebud.ai/play/garden-disk-corp",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/2c02ed5e-4870-4118-9ffd-7c4a511e833c.png?v=1780905895.907385",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/71d5e2c2-52e7-438c-9187-d8c8ef5b414a/index.html",
  },
  {
    slug: "treat-dash-1",
    title: "Cat Treat Runner",
    url: "https://rosebud.ai/play/treat-dash-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/dd003c60-0b36-4c82-9a60-78d2bca7b752.png?v=1785956041.023922",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/1cee41c9-5ebb-41a1-9ce1-1d155bd0adb0/index.html",
  },
  {
    slug: "roundhouse-hockey-1-1",
    title: "Roundhouse Hockey 3D",
    url: "https://rosebud.ai/play/roundhouse-hockey-1-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_April_27_2026_-_10_10AM.jpg?v=1780611371.6421",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/db44d735-2f13-4c5c-be8e-5e28b158bc04/index.html",
  },
  {
    slug: "pastel-planks",
    title: "Tiny Bridge",
    url: "https://rosebud.ai/play/pastel-planks",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/1bcd267f-b9fd-4fee-b1a0-10b88d877cd4.png?v=1778701001.576429",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/67e76afd-3c8f-4cbb-bd1e-cc5e91693981/index.html",
  },
  {
    slug: "2220adb8-104f-430b-8ac3-3b99a07d8039",
    title: "The Winding Path - A Traditional Roguelike RPG",
    url: "https://rosebud.ai/play/2220adb8-104f-430b-8ac3-3b99a07d8039",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ChatGPT_Image_May_11_2026_02_27_17_PM.png?v=1778534925.13587",
  },
  {
    slug: "star-warp",
    title: "Star Warp",
    url: "https://rosebud.ai/play/star-warp",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0fadccf5-4ddb-464a-9ce7-c2747ed8d11c.jpg?v=1780976974.402792",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a93581c7-7951-46f6-abdc-8eed7cb3cb80/index.html",
  },
  {
    slug: "city-surge-1",
    title: "City Surge",
    url: "https://rosebud.ai/play/city-surge-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/be2ffd49-db26-4af2-9f1a-76ab91c6f53a.png?v=1783176623.227294",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/99dbd320-38e7-46bd-9abc-84efb23ee810/index.html",
  },
  {
    slug: "the-seamstress",
    title: "The Seamstress",
    url: "https://rosebud.ai/play/the-seamstress",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e0fb56a8-2ea0-4a20-a6ff-f63a17c81fca.png?v=1780906751.947292",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/f9f7b5d1-a22f-4a80-9237-60348abf105c/index.html",
  },
  {
    slug: "one-more-book",
    title: "One More Book",
    url: "https://rosebud.ai/play/one-more-book",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/2bcccd73-bced-4bf4-904f-29cb4fe23091.png?v=1777930743.233837",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9dbde969-7c2a-46ba-bfe9-ec115298e41d/index.html",
  },
  {
    slug: "bling-smile-studio",
    title: "Bling Smile Studio",
    url: "https://rosebud.ai/play/bling-smile-studio",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/b22ad2b1-4acc-49ac-a1d3-6a4113989df9.jpg?v=1780907876.887037",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/0ec70585-deb8-43b1-b2ac-b025af9ad5dd/index.html",
  },
  {
    slug: "retro-javelin-1",
    title: "Retro Javelin",
    url: "https://rosebud.ai/play/retro-javelin-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_April_27_2026_-_10_08AM.jpg?v=1777916826.347263",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/d708dd5b-9552-4192-ac8b-8726fddfd60b/index.html",
  },
  {
    slug: "pink-tetris",
    title: "Pink Tetris",
    url: "https://rosebud.ai/play/pink-tetris",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/54eee666-7b94-453d-a4ce-a4af3b9b6bb5-thumbnail.png?v=1782739837.308287",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/78650d25-5f32-467e-8193-6a8c48afe12b/index.html",
  },
  {
    slug: "reclamation-simulator-1",
    title: "Reclamation Simulator",
    url: "https://rosebud.ai/play/reclamation-simulator-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/Generated_Image_April_27_2026_-_10_12AM.jpg?v=1777648913.698333",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/f0d16826-0b5b-462f-9583-99763d8d46e3/index.html",
  },
  {
    slug: "sorting-express",
    title: "Factory sort",
    url: "https://rosebud.ai/play/sorting-express",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/efe8f07f-04ac-44c4-adff-beb206c28e1e.png?v=1780908003.496005",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b1a206e5-2483-41a9-97fe-40bc177a1ef1/index.html",
  },
  {
    slug: "merge-munch-tycoon",
    title: "Merge & Munch Tycoon",
    url: "https://rosebud.ai/play/merge-munch-tycoon",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/4d77bb88-3d82-43fe-a471-db56fc20bed7-thumbnail.jpg?v=1784663495.037058",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/57cc9563-9a6f-4eab-bf6a-5b8d4ca97643/index.html",
  },
  {
    slug: "lunarworks",
    title: "LUNARWORKS",
    url: "https://rosebud.ai/play/lunarworks",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/b11328b9-851c-475b-85b5-06a18f0fa615.png?v=1781412869.672685",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9e6529d1-5a8e-45e1-88c3-e7085e654fff/index.html",
  },
  {
    slug: "melody-of-hope",
    title: "Melody of Hope",
    url: "https://rosebud.ai/play/melody-of-hope",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ab61ec01-fd88-4752-b9fd-07fcd5cca486.png?v=1778701049.802529",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/2160c855-b83a-49a3-aa87-ad028a1d350d/index.html",
  },
  {
    slug: "retro-javelin-3d",
    title: "Retro Javelin 3D",
    url: "https://rosebud.ai/play/retro-javelin-3d",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/770ebb81-e501-43f8-bd0f-a9cabc62ae70.png?v=1777923814.718959",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b53f7c2c-dc63-4409-a92f-d987987441a5/index.html",
  },
  {
    slug: "think-ice",
    title: "Thin(k) Ice",
    url: "https://rosebud.ai/play/think-ice",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e519d8c8-04c3-4cc8-a2a5-4c9a54a35969-thumbnail.jpg?v=1787789627.048956",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/45227017-dfa0-453f-acb1-4a0cc332e649/index.html",
  },
  {
    slug: "drift-for-glory-prev",
    title: "DRIFT FOR GLORY",
    url: "https://rosebud.ai/play/drift-for-glory-prev",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a8ed8a2c-c026-4796-8352-5ce3d2a9cd1d.png?v=1786015009.204701",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/4bd86188-39d7-4f5a-97de-9be47ed4e518/index.html",
  },
  {
    slug: "mandible-racer",
    title: "Mandible Racer",
    url: "https://rosebud.ai/play/mandible-racer",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/9850dbe9-5034-4adc-a5e5-9db1fce86b44.png?v=1784744114.60568",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/71652e98-2ec5-4de6-8ea1-50dae13057da/index.html",
  },
  {
    slug: "eagles-skijump",
    title: "Ski Jump Classic: Retro Airborne",
    url: "https://rosebud.ai/play/eagles-skijump",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/4ec950b1-8846-4ca2-9c54-441cfd743e5d.png?v=1779039337.428383",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a7c06c57-a52b-4853-b285-d9ca96c2c0f4/index.html",
  },
  {
    slug: "cratebots",
    title: "CrateBots",
    url: "https://rosebud.ai/play/cratebots",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/5d04ad07-eba5-44bb-957f-109836f3a3f3.png?v=1777828497.618093",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/6c210e46-440e-455a-a27a-6426b89c2779/index.html",
  },
  {
    slug: "net-speed-tycoon-idle-clicker",
    title: "Net Speed Tycoon Idle Clicker",
    url: "https://rosebud.ai/play/net-speed-tycoon-idle-clicker",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f7e97baa-e589-4f03-9041-57a393317602.png?v=1777653430.679516",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/2bdef92b-c42d-4b3f-bc91-1ead56634b26/index.html",
  },
  {
    slug: "feeding-frenzy-depth",
    title: "Abyss Feast",
    url: "https://rosebud.ai/play/feeding-frenzy-depth",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ee8262a9-1df4-4002-96cc-f0c4a720004c.png?v=1785778119.719907",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/bd9a9c9c-2ca1-45df-bcaf-f03d758155da/index.html",
  },
  {
    slug: "cake-chess",
    title: "Cake Chess",
    url: "https://rosebud.ai/play/cake-chess",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/82a4d0d0-54be-4802-985d-54a74bc13e83-thumbnail.png?v=1782493596.383444",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9f0a814d-3630-4fc7-a680-34308d835614/index.html",
  },
  {
    slug: "toy-bed-brawl",
    title: "Toy Bed Brawl",
    url: "https://rosebud.ai/play/toy-bed-brawl",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/39a67b18-a305-45de-b821-33ea80b17ceb-thumbnail.jpg?v=1786205274.66608",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/adce65b3-e1d1-4fcd-bd25-949a46fce871/index.html",
  },
  {
    slug: "marbledraft-race",
    title: "MarbleDraft Race",
    url: "https://rosebud.ai/play/marbledraft-race",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/03d858ae-07ca-43f1-b64b-8ee5ca973217-thumbnail.jpg?v=1786329531.67192",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9ad5e767-3bec-4f37-b3da-d29ee20d74b4/index.html",
  },
  {
    slug: "spell-spark-dressup",
    title: "Spell-Spark Dressup",
    url: "https://rosebud.ai/play/spell-spark-dressup",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/84aef87c-a321-4a8e-b2db-c3261ea4ed3f-thumbnail.jpg?v=1785592070.884911",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b93e819e-197b-40ff-aa22-43aca9f69b11/index.html",
  },
  {
    slug: "street-dodgeball-1",
    title: "Street Dodgeball",
    url: "https://rosebud.ai/play/street-dodgeball-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/877ec36e-124b-4caa-b9cf-3e4390046f60.png?v=1787758463.078196",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7d59bf08-5e35-4dc2-8db0-b343fd610bfb/index.html",
  },
  {
    slug: "f86abd4a-9454-4a2a-b1f7-e2e6112995ab",
    title: "Flip-Phase Zero Theta",
    url: "https://rosebud.ai/play/f86abd4a-9454-4a2a-b1f7-e2e6112995ab",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f86abd4a-9454-4a2a-b1f7-e2e6112995ab.jpg?v=1779729471.905678",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5c638edd-fdcc-430a-a470-e3c8a0be8648/index.html",
  },
  {
    slug: "odd-eyed-style",
    title: "Odd-Eyed Style",
    url: "https://rosebud.ai/play/odd-eyed-style",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d39528fe-5494-458a-9357-657e38096c7b-thumbnail.png?v=1782493598.483127",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/efe36d41-2575-4c4f-83c2-4ab901ef2d9b/index.html",
  },
  {
    slug: "blockfall",
    title: "Blockfall",
    url: "https://rosebud.ai/play/blockfall",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d3557ae8-2482-4f86-a0f7-1e2d05d39cf9-thumbnail.png?v=1783510961.642698",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/4a11cea3-caac-4170-b046-0af9d5429452/index.html",
  },
  {
    slug: "gem-quest",
    title: "Gem Quest",
    url: "https://rosebud.ai/play/gem-quest",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a44fc22d-206c-44e4-80fd-04d5036ba060.jpeg?v=1784575063.566474",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a7456bc6-af28-411a-8d73-450c75bc0a8a/index.html",
  },
  {
    slug: "napdesk-tycoon",
    title: "NapDesk Tycoon",
    url: "https://rosebud.ai/play/napdesk-tycoon",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/9d9af168-cb46-4908-90be-2c07da5e3406-thumbnail.jpg?v=1787586738.066852",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a275978a-2cfe-48a9-9f94-ee829f7e3259/index.html",
  },
  {
    slug: "polyforge-studio",
    title: "PolyForge Studio",
    url: "https://rosebud.ai/play/polyforge-studio",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/205d14fe-5790-4410-824c-c0e0d7bc3516.png?v=1787239659.376475",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a7d5b4c7-6be6-46c7-9407-706949f64689/index.html",
  },
  {
    slug: "mexican-train-score",
    title: "Domino Trains",
    url: "https://rosebud.ai/play/mexican-train-score",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/1561d84b-9a5e-480a-8a97-4519aac85088-thumbnail.jpg?v=1787032673.260209",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b43341f7-7a52-49ac-81be-f6bce4c55ebc/index.html",
  },
  {
    slug: "cityblackhole",
    title: "CityBlackHole",
    url: "https://rosebud.ai/play/cityblackhole",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/c79d1900-e268-447c-bba8-a10667647b4b-thumbnail.jpg?v=1786134520.111008",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/47f4c831-ad92-41b7-9521-46c77879386f/index.html",
  },
  {
    slug: "tramcatala-1",
    title: "Ice rally 93 arcade",
    url: "https://rosebud.ai/play/tramcatala-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f25791ad-2f8b-4db9-a727-9b9e44eabf6c.jpeg?v=1785775667.387438",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/58d1c498-b271-4b7c-90db-f020c0be6695/index.html",
  },
  {
    slug: "roam-farm-tycoon",
    title: "Roam Farm Tycoon",
    url: "https://rosebud.ai/play/roam-farm-tycoon",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/292da0f0-a120-45bf-b42b-a9bd484208a2.jpg?v=1787074510.319556",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3c758de3-9e17-4f7c-aa4d-c47d498f1fe7/index.html",
  },
  {
    slug: "mochi-paws-duel",
    title: "Mochi Paws Duel",
    url: "https://rosebud.ai/play/mochi-paws-duel",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0c9002e0-f065-43e6-a216-485d90c49334-thumbnail.jpg?v=1786269341.195082",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/59e5a249-6e3a-4ac9-a14a-34a1cc584fab/index.html",
  },
  {
    slug: "dusty-rover",
    title: "GRAVRIDER 5000",
    url: "https://rosebud.ai/play/dusty-rover",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/733819e6-283b-4411-a75c-b60d0d7b6110.png?v=1777679184.350799",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/307741c8-fa19-4aa6-8f83-afe77b51f3ae/index.html",
  },
  {
    slug: "ice-cream-studio",
    title: "Ice Cream Studio",
    url: "https://rosebud.ai/play/ice-cream-studio",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/813d7914-302a-435d-8397-2e3459dbc3d3.png?v=1781619209.294874",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/adeaeea8-e1a0-42a4-b3df-239d4c89584b/index.html",
  },
  {
    slug: "pizza-pan",
    title: "Pizza Pan",
    url: "https://rosebud.ai/play/pizza-pan",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e95e1cf1-bd7e-4dd0-8bd8-57d4f545a442.webp?v=1787074515.423423",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/c3d481c0-d9bb-4777-8302-a930d9c121cc/index.html",
  },
  {
    slug: "gridword",
    title: "Gridword",
    url: "https://rosebud.ai/play/gridword",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d1563981-f8c2-4d90-8b90-5812acbf1ce3-thumbnail.png?v=1783510959.410788",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/19dde5e0-8fa4-45f4-8899-188973f9a817/index.html",
  },
  {
    slug: "zen-oracle-temple",
    title: "Zen Oracle Temple",
    url: "https://rosebud.ai/play/zen-oracle-temple",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ChatGPT_Image_May_13_2026_01_34_08_PM.png?v=1778704461.139199",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ebef2bed-23de-4e84-a197-f6f941222f14/index.html",
  },
  {
    slug: "food-war-snake",
    title: "Food War Snake",
    url: "https://rosebud.ai/play/food-war-snake",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0dbf391d-3844-4dbb-a056-6e6af0eaa9df-thumbnail.jpg?v=1784668214.108915",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a3d6736c-4ce4-485e-ab71-de8838e846e3/index.html",
  },
  {
    slug: "magical-chibi-jigsaw-jolt",
    title: "Magical Chibi Jigsaw Jolt",
    url: "https://rosebud.ai/play/magical-chibi-jigsaw-jolt",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/57caa115-7f67-44fd-83f8-ae170b2f44d0.png?v=1781546908.66058",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/e7d18ba1-3283-4228-b6e7-cd965958e53d/index.html",
  },
  {
    slug: "case-couture",
    title: "Case Couture",
    url: "https://rosebud.ai/play/case-couture",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/6193e775-220d-4f7c-97ec-fe8be19e0f6b-thumbnail.png?v=1781619204.688449",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/081830f8-5142-4dc0-8c97-1ecce83e604f/index.html",
  },
  {
    slug: "fruit-merge-drop",
    title: "Fruit Merge Drop",
    url: "https://rosebud.ai/play/fruit-merge-drop",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/01910696-de59-4470-8ee5-c494e370dcb9-thumbnail.jpg?v=1784559139.585473",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/0a21f9e1-b797-4350-8c45-01ec76568642/index.html",
  },
  {
    slug: "traffic-jam",
    title: "Traffic Jam",
    url: "https://rosebud.ai/play/traffic-jam",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3bec5a45-ee28-4015-8094-4ae7dbd897e2.png?v=1778259306.879353",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5d95d6ac-6e4b-495d-a3c3-575c893b429a/index.html",
  },
  {
    slug: "junk-hoopz",
    title: "Junk Hoopz",
    url: "https://rosebud.ai/play/junk-hoopz",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/48ec1ea0-8b23-4710-a3e6-309f9bfa22c9.png?v=1781336820.167231",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ed2bd86c-347f-4fd7-8045-8aadcc32930b/index.html",
  },
  {
    slug: "wedding-cake-wonders-copy",
    title: "Cookie Creations",
    url: "https://rosebud.ai/play/wedding-cake-wonders-copy",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/877207e9-318d-4c49-b46f-d1d84df365f2.png?v=1781546941.701344",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7f7eb301-84fd-4bfd-8c83-43f5decb367c/index.html",
  },
  {
    slug: "candy-world",
    title: "Candy World",
    url: "https://rosebud.ai/play/candy-world",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3c91fdbc-3131-47f7-8d5d-f0076e643824.jpg?v=1787074513.844528",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/e59f89b4-6198-4f31-94f2-8bc8bfc949d9/index.html",
  },
  {
    slug: "duel-52-copy",
    title: "Duel 52",
    url: "https://rosebud.ai/play/duel-52-copy",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d1c18d0c-3496-43d0-8a0d-a36e964a2f75-thumbnail.jpg?v=1786814101.462725",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/18c41a3f-7522-4449-ba0e-c98620202906/index.html",
  },
  {
    slug: "morning-breakfast-truck-tyccon",
    title: "Morning Breakfast Truck Tyccon",
    url: "https://rosebud.ai/play/morning-breakfast-truck-tyccon",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/74aaed84-9a06-442f-8a5c-6bef955e2ae1.jpg?v=1785885712.370814",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/1967c3f4-f02a-4105-8a56-309b32c192f0/index.html",
  },
  {
    slug: "sloppy-redactor",
    title: "SLOPPY REDACTOR",
    url: "https://rosebud.ai/play/sloppy-redactor",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e39dc401-662c-4f4d-9e80-464d723cd607.png?v=1774499132.129168",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/54124dc0-90c2-4cbf-bd1d-34a961e29ad5/index.html",
  },
  {
    slug: "magical-chibi-girls-coloring-book-copy-1",
    title: "Magical Chibi Girls Coloring Book",
    url: "https://rosebud.ai/play/magical-chibi-girls-coloring-book-copy-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/564948fe-a1c7-41fb-9940-6fa171c5e7bb.png?v=1782493594.413082",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/2abb1bb4-193b-491c-b4ad-d9fc46aeed88/index.html",
  },
  {
    slug: "trash-dash",
    title: "Trash Dash",
    url: "https://rosebud.ai/play/trash-dash",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0ebc5fc0-ac81-4df4-8352-1c6f72e54e84.png?v=1781546959.398661",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/c528f799-d18f-43ec-af3f-e78ee8c7c856/index.html",
  },
  {
    slug: "tornado-thrive",
    title: "Tornado Thrive",
    url: "https://rosebud.ai/play/tornado-thrive",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/6915f8ab-35af-4437-aa77-f77f14b73754-thumbnail.jpg?v=1786134502.650931",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/f8a07a82-f4ab-4aef-8a2e-6c6f09ba50c5/index.html",
  },
  {
    slug: "poki-pan",
    title: "Poki Pan",
    url: "https://rosebud.ai/play/poki-pan",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0ce3e969-0dfb-4e37-b7e5-4423b2ac07bb-thumbnail.jpg?v=1784559131.359691",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/159a9385-33c0-4a5e-8bbb-a388ae4134a6/index.html",
  },
  {
    slug: "bouncy-hoops",
    title: "Bouncy Hoops",
    url: "https://rosebud.ai/play/bouncy-hoops",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/8bece678-fe62-447d-8783-533ab69d9713-thumbnail.jpg?v=1786134395.136116",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/c82c0c9f-0305-4bbe-9568-f7c1f24cbffe/index.html",
  },
  {
    slug: "blob-lane-dash",
    title: "Blob Lane Dash",
    url: "https://rosebud.ai/play/blob-lane-dash",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ca4f4ebe-54be-4bd8-956c-5df3ad74f0a6-thumbnail.png?v=1783510955.337285",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3b0a7140-99b4-481e-97d0-2ee2e774870f/index.html",
  },
  {
    slug: "time-to-frost",
    title: "Time to Frost",
    url: "https://rosebud.ai/play/time-to-frost",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a2e49d4e-0899-408b-b3ef-ca3d881cfb8d.png?v=1781546950.895716",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/84321bc0-1284-4ccd-bc2e-7d8d7810f58a/index.html",
  },
  {
    slug: "kawaii-cascade",
    title: "Kawaii Cascade",
    url: "https://rosebud.ai/play/kawaii-cascade",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/51f98064-2695-41bc-ba41-08badfe98d64.png?v=1781546970.37727",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/540a2a98-e325-41ab-9573-d95846e4697e/index.html",
  },
  {
    slug: "horse-studio",
    title: "Horse Studio",
    url: "https://rosebud.ai/play/horse-studio",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/84973919-c98e-4627-b846-e9985f726e6c.png?v=1781619222.946395",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/cdd30654-0ae8-4a42-8708-1e0e914b29f2/index.html",
  },
  {
    slug: "neon-rush-12",
    title: "Velocity rush",
    url: "https://rosebud.ai/play/neon-rush-12",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/39c3f22a-582e-41b8-b157-195518286194.png?v=1784664917.018501",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9f616a3d-755a-443c-8b7f-25bc1e36b28b/index.html",
  },
  {
    slug: "nanobot-infection",
    title: "Nanobot Infection",
    url: "https://rosebud.ai/play/nanobot-infection",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/fb0880f4-2042-487d-b7f2-7368e3d7e31a-thumbnail.jpg?v=1787508146.495247",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/7f403d1b-75dc-4646-8744-520b76f2d14b/index.html",
  },
  {
    slug: "chibi-academy-memory-match",
    title: "Chibi Academy Memory Match",
    url: "https://rosebud.ai/play/chibi-academy-memory-match",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/0351748b-b64f-4d27-8ccb-2dcf01c4a4f9.png?v=1781546937.953727",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9fd9d406-cae6-4d14-8034-843f2b3d6476/index.html",
  },
  {
    slug: "elf-fishing-life",
    title: "ELF Fishing Life",
    url: "https://rosebud.ai/play/elf-fishing-life",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/427b1548-9e87-496d-aa12-473dfccfdc22-thumbnail.jpg?v=1786860800.436678",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/48ee4c69-d43d-44d2-8fef-6463e6a2a018/index.html",
  },
  {
    slug: "turbo-lane",
    title: "Turbo Lane",
    url: "https://rosebud.ai/play/turbo-lane",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/927d583d-fd78-48d8-933b-2d7555264c22.png?v=1781455977.605117",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ff098f9b-7ee6-4c30-9177-a9c9efce61ab/index.html",
  },
  {
    slug: "e65a92dc-a09a-42d2-98bc-250bfcff1098",
    title: "PING",
    url: "https://rosebud.ai/play/e65a92dc-a09a-42d2-98bc-250bfcff1098",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e65a92dc-a09a-42d2-98bc-250bfcff1098.png?v=1758433754.642866",
  },
  {
    slug: "pattern-merge",
    title: "Pattern Merge",
    url: "https://rosebud.ai/play/pattern-merge",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3b766e6d-6c47-4e9c-a103-95d4cdec388f-thumbnail.jpg?v=1784663421.545881",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3c0d2ce6-5628-4521-b89c-6a37ce5beec2/index.html",
  },
  {
    slug: "emojibrawl",
    title: "Emojibrawl",
    url: "https://rosebud.ai/play/emojibrawl",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f9e0a2b6-d207-4537-9562-5fb7595e1763-thumbnail.png?v=1786907648.927285",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/183f6f27-2814-4a7b-bbf1-0f6d1e14937c/index.html",
  },
  {
    slug: "quantum_agent-1",
    title: "Quantum_Agent",
    url: "https://rosebud.ai/play/quantum_agent-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/801ecfc3-9bb5-491e-b363-78fb698b7868.png?v=1779378387.265597",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/236d1c51-b3dc-42ad-96c7-1bfbc1ccbf26/index.html",
  },
  {
    slug: "cosmic-rush-1",
    title: "Cosmic rush",
    url: "https://rosebud.ai/play/cosmic-rush-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/4b8fcdcc-9692-438f-b290-5582787fc4ee.jpeg?v=1784575614.745343",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a4761e55-3537-4234-8b89-d096e3f16f80/index.html",
  },
  {
    slug: "brain-test-battle-1",
    title: "Brain Test: Battle",
    url: "https://rosebud.ai/play/brain-test-battle-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e8e9c8bf-8213-4a57-9f30-331913f1f2e5.webp?v=1786796255.407818",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/72ad23aa-fc8d-447a-b4f2-74b04dea4033/index.html",
  },
  {
    slug: "forest-jigsaw",
    title: "Forest Jigsaw",
    url: "https://rosebud.ai/play/forest-jigsaw",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7ab27951-92db-47d9-a3b3-4fd7c6619308-thumbnail.jpg?v=1785654955.796623",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/fedf7bbe-aecd-4229-a356-e2890f143184/index.html",
  },
  {
    slug: "par-roll",
    title: "Par & Roll",
    url: "https://rosebud.ai/play/par-roll",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ba684844-e75d-4e77-a2a5-837f78a5fde7-thumbnail.jpg?v=1784662449.097093",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3db9fd16-2352-4ecd-b128-fcf44f597955/index.html",
  },
  {
    slug: "king-myco-neon-throw-copy",
    title: "King Myco Neon Throw V3",
    url: "https://rosebud.ai/play/king-myco-neon-throw-copy",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/efeb4067-6cfc-4fd0-b7fe-60884246b2af-thumbnail.jpg?v=1784812682.215215",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/c85cb5c1-2c3b-4402-9f7a-23a5f7c67868/index.html",
  },
  {
    slug: "gold-rush-mine-empire",
    title: "Gold Rush: Mine Empire",
    url: "https://rosebud.ai/play/gold-rush-mine-empire",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/739e7cd7-983f-4c66-8392-7f0857aa833c-thumbnail.jpg?v=1785245043.3187",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/4e7258e0-79b4-4602-a531-00063abb0541/index.html",
  },
  {
    slug: "chrono-critters",
    title: "Chrono-Critters 1.0 Released",
    url: "https://rosebud.ai/play/chrono-critters",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ChatGPT_Image_May_11_2026_01_37_49_PM.png?v=1778531889.899203",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/89686925-5ba7-4aa8-a404-5965519900f4/index.html",
  },
  {
    slug: "microbe-tap",
    title: "Mircobe Tap",
    url: "https://rosebud.ai/play/microbe-tap",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/abe3fbb1-0d35-4536-89bd-dbc0282c393f-thumbnail.jpg?v=1784946826.470427",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/c5ab4540-5359-4feb-b696-20e9903cb2fb/index.html",
  },
  {
    slug: "grime-sprayer",
    title: "Grime Sprayer",
    url: "https://rosebud.ai/play/grime-sprayer",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/7b7dd2cd-6400-4ee9-8aab-4e49dc4258e0.png?v=1781546956.720078",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/9fc5e7e1-0e85-4e33-a156-dd96e8f1d532/index.html",
  },
  {
    slug: "bakery-match-3",
    title: "Bakery Match 3",
    url: "https://rosebud.ai/play/bakery-match-3",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/2b33f8a6-9d37-4bd6-8e12-97196d92a10e.jpg?v=1784560409.016492",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/00d26ccc-b8a6-4449-8f73-3c78c1215e5d/index.html",
  },
  {
    slug: "rebenta-os-baloes",
    title: "Rebenta os Balões",
    url: "https://rosebud.ai/play/rebenta-os-baloes",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/815ac31c-7b57-4db2-b04d-52408417ee9e-thumbnail.jpg?v=1784805480.17049",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/30f9446c-6fc1-4734-875d-d1bd8c396433/index.html",
  },
  {
    slug: "bichinhos-coloridos",
    title: "Bichinhos Coloridos",
    url: "https://rosebud.ai/play/bichinhos-coloridos",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/81b8e5fe-42ca-45e3-90e1-4e548e129c69-thumbnail.jpg?v=1784660663.268612",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/bb9b23ab-5180-4a54-8574-39e769a61228/index.html",
  },
  {
    slug: "donut-studio",
    title: "Donut Studio",
    url: "https://rosebud.ai/play/donut-studio",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/db1e74d5-273b-4d4b-b7d6-ecf441b14252.png?v=1781546973.704206",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/491904f3-5f4a-4870-9184-adcc0b4e2ef3/index.html",
  },
  {
    slug: "pizza-creations",
    title: "Pizza Creations",
    url: "https://rosebud.ai/play/pizza-creations",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/bbd48f1c-0340-4800-807d-bfc6ad688ffd.png?v=1781546953.46682",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/8fdbe9fe-8f4e-4865-84c3-1fc683d1c725/index.html",
  },
  {
    slug: "loopterritory-copy",
    title: "LoopTerritory",
    url: "https://rosebud.ai/play/loopterritory-copy",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/864df194-14b2-453e-bcfe-719b3765e183-thumbnail.jpg?v=1786134406.643331",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3694e989-1f31-4218-9cec-85f2b0fa8315/index.html",
  },
  {
    slug: "tic-tac-toe-vs-ai",
    title: "Tic Tac Toe vs AI",
    url: "https://rosebud.ai/play/tic-tac-toe-vs-ai",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/6429f795-03da-4774-a810-36d7de1393d4-thumbnail.png?v=1783510957.381673",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/4995d9f8-12c8-4fcf-a02a-4b530533242f/index.html",
  },
  {
    slug: "xon-nox",
    title: "XON-NOX!",
    url: "https://rosebud.ai/play/xon-nox",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/c8836692-9f42-46a0-ad92-3a3bcdb8a58f.png?v=1782493602.283325",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/f0533e99-3f89-4554-bc6a-38a4d75b9bb3/index.html",
  },
  {
    slug: "jabirs-haven-restore",
    title: "Jabir’s Haven Restore",
    url: "https://rosebud.ai/play/jabirs-haven-restore",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/4e5b80d7-40b5-49f1-bdd0-b0d6c8642ab7-thumbnail.jpg?v=1785241578.176044",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a3a0b5ae-695d-4f55-83fb-b818525a4ada/index.html",
  },
  {
    slug: "cake-smash-arena",
    title: "Cake Smash Arena",
    url: "https://rosebud.ai/play/cake-smash-arena",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/30dcb233-f7da-405f-b0d6-bb5db241db28.png?v=1781619214.078014",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/cf65c0ce-cd69-4422-92fb-9ad696e07068/index.html",
  },
  {
    slug: "cupcake-studio",
    title: "Cupcake Studio",
    url: "https://rosebud.ai/play/cupcake-studio",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/c5827a0e-db68-4e2b-84a3-87d10eb86a44.png?v=1781546965.219245",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5f8352d4-cb5c-4bd0-b4ca-295354af07ea/index.html",
  },
  {
    slug: "vintage-poster-rescue",
    title: "Vintage Poster Rescue",
    url: "https://rosebud.ai/play/vintage-poster-rescue",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/65a55a61-c320-471a-af6a-1e78b6ca261a.png?v=1780907755.300969",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/f1723655-91dd-40db-a600-50266506aabe/index.html",
  },
  {
    slug: "kitty",
    title: "!Kitty",
    url: "https://rosebud.ai/play/kitty",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f5a3688d-da77-440e-915c-fd8ac56cd538.png?v=1785854860.02041",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/6a084f61-2675-44c8-bd4f-061ec00b2baa/index.html",
  },
  {
    slug: "sigilbound-mystical-grid-strategy",
    title: "Sigilbound V2 - Mystical Grid Strategy",
    url: "https://rosebud.ai/play/sigilbound-mystical-grid-strategy",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/b65810b5-1f25-45b6-926e-0a84175ca3cf.png?v=1780665099.284489",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/f52df041-0ad7-4b0b-8b95-76a8e62c14d1/index.html",
  },
  {
    slug: "2024-merge-rush",
    title: "2024 Merge Rush",
    url: "https://rosebud.ai/play/2024-merge-rush",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ead6b542-6d53-470f-8060-e2a08789227e-thumbnail.png?v=1782493604.429751",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ebfcbe41-b0d7-4f6b-9abc-33451313e33f/index.html",
  },
  {
    slug: "rps60",
    title: "RPS60",
    url: "https://rosebud.ai/play/rps60",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/b05ebfec-8078-4ede-b976-b5b50c39da08-thumbnail.jpg?v=1785119356.868784",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/61c2f991-305c-4623-bb1c-fff78cb56958/index.html",
  },
  {
    slug: "cakey-road",
    title: "Cakey Road",
    url: "https://rosebud.ai/play/cakey-road",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/68d6fd74-ab19-4562-8bd3-ab1da4872fdb.png?v=1781619194.921812",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/92a92841-57ed-4a83-a7cd-f72cb90e22fa/index.html",
  },
  {
    slug: "crackers-creations",
    title: "Crackers Creations",
    url: "https://rosebud.ai/play/crackers-creations",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/3a4fec5a-a0f3-4dae-9f77-e80cbb7bbdef.png?v=1781546967.879201",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/792356bb-9c67-45cf-b093-fa6b99bd449a/index.html",
  },
  {
    slug: "bubble-pop-panic",
    title: "Bubble Pop Panic",
    url: "https://rosebud.ai/play/bubble-pop-panic",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/63bed82b-cce7-4738-92df-4f93cb021ad6-thumbnail.jpg?v=1784559128.621887",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/e1afcc44-5f59-498b-b8dd-b4b2f6bb2884/index.html",
  },
  {
    slug: "ctrlslow",
    title: "CTRL//SLOW",
    url: "https://rosebud.ai/play/ctrlslow",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/b7230945-a517-4320-9716-2281578bd00d.png?v=1780265932.508341",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/136ca0cc-505d-454c-a4f6-810debd2c700/index.html",
  },
  {
    slug: "cake-checkers",
    title: "Cake Checkers",
    url: "https://rosebud.ai/play/cake-checkers",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a225117c-0397-4e5f-99d6-17acf2a9eaa7-thumbnail.png?v=1782493600.400333",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/cd985e6f-a0a0-46b2-8fbd-505a22fa986c/index.html",
  },
  {
    slug: "glam-wash-sparkle-spa",
    title: "Pet Wash Sparkle Spa",
    url: "https://rosebud.ai/play/glam-wash-sparkle-spa",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/c91739ea-2b28-4071-bb2a-b4d0a9ad0b82.png?v=1781619200.318322",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a029c5fa-56c1-4702-bc97-c6373c574686/index.html",
  },
  {
    slug: "brownie-creations",
    title: "Brownie Creations",
    url: "https://rosebud.ai/play/brownie-creations",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/d2a859ef-2c78-48a3-93e6-9085802dac91.jpeg?v=1781546947.827591",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/6d577c99-37d8-4db1-b8ba-f8c29997738d/index.html",
  },
  {
    slug: "chave-porta-joao",
    title: "Chave & Porta João",
    url: "https://rosebud.ai/play/chave-porta-joao",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ec95218d-b524-4d8f-8684-4551f16dbb09-thumbnail.jpg?v=1784814004.51241",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/89a61fd6-39ac-40d4-86e0-a6d802ff417f/index.html",
  },
  {
    slug: "longboat-panic",
    title: "Longboat Panic",
    url: "https://rosebud.ai/play/longboat-panic",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e6e22d39-fd07-4b02-b8d0-05dbe057bbce.jpg?v=1780266000.847778",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/49bf6fdb-638a-4353-87c0-5e2351eb6c08/index.html",
  },
  {
    slug: "bazaar-sort-a-thon",
    title: "Sort-A-Thon",
    url: "https://rosebud.ai/play/bazaar-sort-a-thon",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e47cb089-c6dd-47d4-b671-c5f797e3bb8a.png?v=1781336731.89596",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/501e0088-2c98-4626-bd4b-3d74ad265cce/index.html",
  },
  {
    slug: "go-fish",
    title: "Go Fish",
    url: "https://rosebud.ai/play/go-fish",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/5ac3a8c3-5fbc-4bee-9b28-38b5d7f515c3-thumbnail.png?v=1782493607.783083",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/5a558557-7412-439a-bc90-8e9ed1ba72b7/index.html",
  },
  {
    slug: "sudoku-notes",
    title: "Sudoku Notes",
    url: "https://rosebud.ai/play/sudoku-notes",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/bd31e31a-b851-42e9-80b1-4dc45a21cbba-thumbnail.png?v=1783510950.154029",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/fa257f16-3f24-4cb5-ab74-c36bc8984151/index.html",
  },
  {
    slug: "droid-mines",
    title: "Droid Mines",
    url: "https://rosebud.ai/play/droid-mines",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/761cc6da-9a10-4086-a040-c48e0c12a4da-thumbnail.png?v=1783510948.615534",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/3faaec66-275f-4ac1-b80f-ba76c3d8d0fb/index.html",
  },
  {
    slug: "ilhas-anonimas",
    title: "Ilhas Anônimas",
    url: "https://rosebud.ai/play/ilhas-anonimas",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/a9b0af29-c0b9-4cbf-a57e-aeb1251d3a7e-thumbnail.jpg?v=1787775769.981972",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b0e54ca3-590d-458e-b418-674ab936d80b/index.html",
  },
  {
    slug: "magic-mouse-studio",
    title: "Magic Mouse Studio",
    url: "https://rosebud.ai/play/magic-mouse-studio",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/74016e3f-ee8a-4f74-b64b-0eb873c16949.png?v=1781623551.568794",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/afe99c5d-af79-4bdc-b733-67e8e9cdc13c/index.html",
  },
  {
    slug: "enchanted-forest-tic-tac-toe",
    title: "Enchanted Forest Tic Tac Toe",
    url: "https://rosebud.ai/play/enchanted-forest-tic-tac-toe",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f2a041d7-5798-4c2a-bc40-ec0ee150cb9f.png?v=1782493609.592284",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/b9b0f175-4a21-4a65-8644-6fce33b121f0/index.html",
  },
  {
    slug: "cat-harvester-idle",
    title: "Cat Harvester Idle",
    url: "https://rosebud.ai/play/cat-harvester-idle",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/df65966b-0b4b-4940-8ce8-7d97e7c12b7f.png?v=1784188518.927282",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/66b36963-77e5-46e3-a32a-ee1f8092ede6/index.html",
  },
  {
    slug: "cozy-home-decor",
    title: "Cozy Home Decor",
    url: "https://rosebud.ai/play/cozy-home-decor",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/376cbd26-6f93-40f3-9360-1b3398ba8b5b-thumbnail.jpg?v=1787700474.798489",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/2193d43b-cf10-48e6-93af-66b696b5ebd7/index.html",
  },
  {
    slug: "neon-midi-voyager-1",
    title: "Step/16",
    url: "https://rosebud.ai/play/neon-midi-voyager-1",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/e761b444-2025-4158-ae42-eaacc3a53237.png?v=1787701750.143513",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/184360de-0ed7-4484-86c5-125ee347e56b/index.html",
  },
  {
    slug: "hiragana-valley",
    title: "Hiragana Valley",
    url: "https://rosebud.ai/play/hiragana-valley",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/fb2e364a-cdf5-4f39-8156-5d6fdd5b2799.png?v=1787976325.444666",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/46853e37-46ef-474f-b507-90ba417d279c/index.html",
  },
  {
    slug: "chefs-challenge",
    title: "Chef’s Challenge",
    url: "https://rosebud.ai/play/chefs-challenge",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/ae477f32-a3ac-42ba-8010-cd3f3b2747ff.webp?v=1787872263.990599",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ff6a58e4-4f4c-42ce-9837-57bca246d079/index.html",
  },
  {
    slug: "neon-triangle-dash",
    title: "Neon Drift",
    url: "https://rosebud.ai/play/neon-triangle-dash",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/691ba9d6-b7e4-4abf-95b6-4fbf435ed1d2.png?v=1787787277.290387",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/ca613238-fe78-41b4-8478-9c76626c1559/index.html",
  },
  {
    slug: "pigment-house",
    title: "Pigment House",
    url: "https://rosebud.ai/play/pigment-house",
    coverUrl: "https://storage.googleapis.com/rosebud_assets_storage/project_preview_images/f7cc92c1-319b-46d6-9da7-24d5246341f5-thumbnail.jpg?v=1787826693.758889",
    gatewayUrl: "https://playground-gateway-v2-snduoq54tq-uc.a.run.app/api/server/a06816bd-fbab-47ef-af9f-0c0dea13cfe7/index.html",
  },
];
